// extracted by mini-css-extract-plugin
export default {"publicationStateInfo":"SnapList__publicationStateInfo-TwSR5","link":"SnapList__link-is9gu","name":"SnapList__name-l0zx0"};